<template>
    <v-form
        v-model="valid"
        ref="form"
        :disabled="disabled || isSubmitting"
        :loading="isLoadingDepartments || isLoadingUsers"
    >
        <v-row class="ma-0">

            <!-- <v-col cols="12" >
                <v-text-field 
                    v-model="requested_at"
                    label="Pedido a*"
                    type="datetime-local"
                    :max="formatDateTimeLocal(new Date())"
                    :clearable="!readonly"
                    :rules="[validationRules.required(requested_at)]"
                    :disabled="disabled || isSubmitting"
                    :readonly="readonly"
                ></v-text-field>
            </v-col> -->
            <v-col cols="12" >
                <v-autocomplete 
                    v-model="assigned_user_id"
                    :label="isLoadingUsers 
                            ? 'Obtendo lista de colaboradores...' 
                            : 'Colaborador a transferir*'
                        " 
                    :items="usersList" 
                    :item-title="(item) => `${item?.worker_code ? item.worker_code + ' - ': ''}${item?.name ?? item?.email ?? item?.username ?? 'ERRO: Nome indisponível'}`" 
                    item-value="id"
                    :disabled="disabled || isLoadingUsers || isSubmitting"
                    :readonly="readonly || !!props.request"
                    :loading="isLoadingUsers"
                    :clearable="!readonly && !props.request"
                    :menu-icon="readonly || !!props.request ? '': undefined"
                    @update:modelValue="initial_department_id = assignedUser?.paid_by_department_id"
                    :rules="[validationRules.required(assigned_user_id)]"
                    autocomplete="off"
                ></v-autocomplete>
            </v-col>
        </v-row>
        <v-row class="ma-0">
            <v-col cols="12">
                <v-autocomplete 
                    v-model="initial_department_id"
                    :label="isLoadingDepartments
                            ? 'Obtendo lista de CCs...'
                            : 'CC inicial'
                            " 
                    :items="initialDepartmentsList" 
                    :item-title="(dep) => `${dep?.external_key ? dep.external_key + ' - ' : ''}${dep?.name ?? 'Centro de Custo sem Nome'}`"
                    item-value="id"
                    :disabled="disabled || isSubmitting"
                    readonly
                    :loading="isLoadingDepartments"
                    menu-icon=""
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" >
                <v-autocomplete 
                    v-model="final_department_id"
                    :label="isLoadingDepartments
                            ? 'Obtendo lista de CCs...'
                            : 'CC final'
                            " 
                    :items="finalDepartmentsList" 
                    :item-title="(dep) => `${dep?.external_key ? dep.external_key + ' - ' : ''}${dep?.name ?? 'Centro de Custo sem Nome'}`"
                    item-value="id"
                    :disabled="disabled || !assigned_user_id || isLoadingDepartments || isSubmitting"
                    :readonly="readonly"
                    :loading="isLoadingDepartments"
                    :clearable="!readonly"
                    autocomplete="off"
                    :menu-icon="readonly ? '': undefined"
                    :rules="[validationRules.required(final_department_id)]"
                ></v-autocomplete>
            </v-col>
        </v-row>
        
        <v-row class="ma-0" v-if="request?.initial_department_approved_at || request?.initial_department_denied_at">
            <!-- <h3>Estado do pedido no CC inicial</h3>
                <v-col cols="12">
                    <v-radio-group 
                        v-model="initial_decision" 
                        :label="`Decisão do CC inicial${initialDecisionLabel ? ': ' + initialDecisionLabel : ''}`"
                        :error-messages="initialDecisionErrorMessages"
                        :rules="[validationRules.required(initial_decision)]"
                        :disabled="disabled || isSubmitting"
                        :readonly="readonly"
                    > -->
                        <!-- <v-radio label="Pendente" :value="0"></v-radio> -->
                        <!-- <v-radio label="Aprovado" :value="1"></v-radio>
                        <v-radio label="Recusado" :value="-1"></v-radio>
                    </v-radio-group>
                </v-col> -->
            
            <v-expand-transition>
                <DepartmentMembershipRequestApprovalFields
                    v-if="initial_decision === 1"
                    v-model:approved-at="initial_department_approved_at"
                    v-model:approved-by-user-id="initial_department_approved_by_user_id"
                    :users="initialApprovedByUsers"
                    :is-loading-users="isLoadingUsers"
                    :min-date-time="formatDateTimeLocal(new Date())"
                    :disabled="/* !requested_at || */ disabled || isSubmitting"
                    :readonly="readonly"
                    :is-submitting="isSubmitting"
                    department-type="initial"
                />
            </v-expand-transition>
            <v-expand-transition>
                <DepartmentMembershipRequestDenialFields
                    v-if="initial_decision === -1"
                    v-model:denied-at="initial_department_denied_at"
                    v-model:denied-by-user-id="initial_department_denied_by_user_id"
                    :users="initialDeniedByUsers"
                    :is-loading-users="isLoadingUsers"
                    :min-date-time="formatDateTimeLocal(new Date())"
                    :disabled="/* !requested_at || */ disabled || isSubmitting"
                    :readonly="readonly"
                    :is-submitting="isSubmitting"
                    department-type="initial"
                />
            </v-expand-transition>
        </v-row>
        <v-row class="ma-0">
            <v-col cols="12">
                <v-date-input 
                    v-model="transfer_date" 
                    :clearable="!readonly" 
                    :readonly="readonly"
                    label="Data de transferência" 
                    :disabled="disabled || isSubmitting" 
                    autocomplete="off"
                    prepend-icon=""
                    :rules="[validationRules.required(transfer_date)]"
                />
            </v-col>
        </v-row>
        <!-- <v-row class="ma-0">
            <v-col cols="12">
                <v-textarea
                    v-model="observations"
                    :label="'Observações'"
                    :clearable="!readonly"
                    :disabled="disabled || isSubmitting"
                    :readonly="readonly"
                    auto-grow
                    rows="3"
                />
            </v-col>
        </v-row> -->
    </v-form>
</template>
<script setup>
import { computed, onMounted, ref} from "vue";
import User from "@/api/User";
import Department from "@/api/departments/Department";
import {formatDateTimeLocal, normalizeDateTime} from "@/composables/datetime";
import validationRules from "@/composables/formValidationRules";
import DepartmentMembershipRequestApprovalFields from "./DepartmentMembershipRequestApprovalFields.vue";
import DepartmentMembershipRequestDenialFields from "./DepartmentMembershipRequestDenialFields.vue";
import DepartmentMembershipRequests from "@/api/departments/membership-requests/DepartmentMembershipRequests"

// component lifecycle and properties
const props = defineProps({
    disabled: {
        type: Boolean,
        default: false,
    },
    readonly: {
        type: Boolean,
        default: false,
    },
    onSubmit: {
        type: Function,
        default: null,
    },
    request: {
        type: Object,
        default: null,
    },
    mode: {
        type: String,
        default: "create",
    },
    idempotency_key : {
        type: String,
        default: null,
    }
})

onMounted(() => {
    fillBaseData();
})

defineExpose({
    validate,
    submit,
});

// Create one key for the mounted dialog instance so retries of the same
// action retain the same idempotency key.
const actionIdempotencyKey =
    props.idempotency_key
    ?? self?.crypto?.randomUUID() 
    ?? null
    ;

// form states
const form = ref("form")
const isLoadingDepartments = ref(false);
const isLoadingUsers = ref(false);
const isSubmitting = ref(false);


// form fields
const assigned_user_id = ref(null);
// const final_decision = ref(null);
// const final_department_approved_at = ref(null);
// const final_department_approved_by_user_id = ref(null);
// const final_department_denied_at = ref(null);
// const final_department_denied_by_user_id = ref(null);
const final_department_id = ref(null);
const initial_decision = ref(null);
const initial_department_approved_at = ref(null);
const initial_department_approved_by_user_id = ref(null);
const initial_department_denied_at = ref(null);
const initial_department_denied_by_user_id = ref(null);
const initial_department_id = ref(null);
// const observations = ref(null);
const transfer_date = ref(null);
// const requested_at = ref(null);
const valid = ref(false);

// dynamic data
const departmentsList = ref([]);
const usersList = ref([]);

// watch(
//     () => props.request,
//     (request) => {
//         fillRequestData(request);
//     },
//     {
//         immediate: true,
//     },
// );

// computed properties
const initialApprovedByUsers = computed(() => {
    if (!props.request?.initial_department_approved_by_user_id) {
        return [];
    }

    return [
        {
            id: props.request.initial_department_approved_by_user_id,
            name: props.request.initial_department_approved_by,
        },
    ];
});

const initialDeniedByUsers = computed(() => {
    if (!props.request?.initial_department_denied_by_user_id) {
        return [];
    }

    return [
        {
            id: props.request.initial_department_denied_by_user_id,
            name: props.request.initial_department_denied_by,
        },
    ];
});
const initialDepartmentsList = computed(() => {
    if (assignedUser.value && departmentsList.value.length && assignedUser.value?.paid_by_department_id) {
        return departmentsList.value.filter((d) => assignedUser.value?.paid_by_department_id == d.id );
    }

    return departmentsList.value || [];
});

const finalDepartmentsList = computed(() => {
    if (assignedUser.value && departmentsList.value.length /* && assignedUser.value?.paid_by_department_id */) {
        return departmentsList.value.filter((d) => assignedUser.value?.paid_by_department_id != d.id && initial_department_id.value != d.id);
    }

    return departmentsList.value || [];
})

// const finalDenyingUsersList = computed(() => {
//     if(
//         usersList.value.length
//         && final_department_id.value
//     ) {
//         return usersList.value?.filter((user) => {
//             return user?.departments?.[final_department_id.value]?.includes(denyRequestPermission);
//         })
//     }

//     return [];
// });

// const finalApprovingUsersList = computed(() => {
//     if (
//         usersList.value.length
//         && final_department_id.value
//     ) {
//         return usersList.value.filter((user) => {
//             return user?.departments?.[final_department_id.value]?.includes(approveRequestPermission);
//         });
//     }

//     return [];
// });

const assignedUser = computed(() => {
    return usersList.value?.find((u) => u.id == assigned_user_id.value)
});

const initialDecisionErrorMessages = computed(() => {
    let messageQueue = [];
    // if (!requested_at.value
    //     && ![null, undefined, Number(0)].includes(initial_decision.value)
    // ) {
    //     messageQueue.push("É necessário escolher uma data para o pedido para poder preencher os campos relativos ao estado do pedido.")
    // }

    return messageQueue;
});

// const finalDecisionErrorMessages = computed(() => {
//     let messageQueue = [];
//     if (!requested_at.value 
//         && ![null, undefined, Number(0)].includes(final_decision.value)
//     ) {
//         messageQueue.push("É necessário escolher uma data para o pedido para poder preencher os campos relativos ao estado do pedido.")
//     }

//     if (!initial_department_approved_at.value 
//         && ![null, undefined, Number(0)].includes(final_decision.value)
//     ) {
//         messageQueue.push("É necessário escolher uma data para a aprovação do pedido no CC initial para poder preencher a decisão do CC final.")
//     }
    
//     return messageQueue;
// });

const decisionLabels = {
    0: "Pendente",
    1: "Aprovado",
    "-1": "Recusado",
};

const initialDecisionLabel = computed(() => {
    return decisionLabels[initial_decision.value] ?? "";
});
// const finalDecisionLabel = computed(() => {
//     return decisionLabels[final_decision.value] ?? "";
// });


// functions
async function fillBaseData(request = props.request) {

    if (request) {

        fillRequestData(request);

        return;
    }
    
    // NEXUS-37 - Alice Serina - 16/06/2026
    // Previously there was an explict call here to sync with Olympus
    // but that caused massive delays the first time the Users open the dialog
    // The sync operation is now properly dispatched to a job that runs
    // automatically keeping information fresh(ish)

    try {
        fetchUsersList();
        fetchDepartmentsList();
        ;
    } catch (error) {
        console.error(error);
    } finally {

    }

}

function fillRequestData(request) {
    if (!request) {
        return;
    }

    let initial_department = {
        id: request.initial_department_id,
        name: request.initial_department,
    }

    let final_department = {
        id: request.final_department_id,
        name: request.final_department,
    }

    let assigned_user = {
        id: request.assigned_user_id,
        name: request.assigned_user,
    }

    // requested_at.value = formatDateTimeLocal(request.requested_at);

    final_department_id.value = request.final_department_id;

    initial_department_id.value = request.initial_department_id;
    initial_decision.value = request?.initial_department_approved_at ? 1 : (request?.initial_department_denied_at ? -1 : null);
    initial_department_approved_at.value = formatDateTimeLocal(request.initial_department_approved_at);
    initial_department_approved_by_user_id.value = request.initial_department_approved_by_user_id;
    initial_department_denied_at.value = formatDateTimeLocal(request.initial_department_denied_at);
    initial_department_denied_by_user_id.value = request.initial_department_denied_by_user_id;
    
    assigned_user_id.value = request.assigned_user_id;

    usersList.value = [
        {...assigned_user}
    ];
    departmentsList.value = [
        {...initial_department},
        {...final_department}
    ];

    transfer_date.value = request.transfer_date;
    // observations.value = request.observations;

    if(["create", "update", "edit"].includes(props.mode) ) {
        fetchDepartmentsList();
    }

}

// function formatDateTimeLocal(value) {
//     return value ? dayjs(value).format("YYYY-MM-DDTHH:mm:ss") : null;
// }

// function normalizeDateTime(value) {
//     return value ? dayjs(value).format("YYYY-MM-DD HH:mm:ss") : null;
// }
 
async function validate() {
    const result = await form.value.validate()
    return result.valid;
    
}

async function submit() {

    isSubmitting.value = true;

    const shouldValidate = [
        "create",
        "update",
        "edit",
    ].includes(props.mode) && !props.disabled;

    const formValues = resolveFormValues();

    try {
        if (shouldValidate) {
            const passedValidation = await validate();

            if (!passedValidation) {
                console.warn(
                    "Validação falhou no DepartmentMembershipRequestForm",
                    formValues,
                );

                return false;
            }
        }

        if (props.onSubmit) {
            return await props.onSubmit(formValues);
        }

        return await DepartmentMembershipRequests.create(formValues);
    } catch (error) {
        console.error(
            "Erro no submit DepartmentMembershipRequestForm:",
            error,
        );

        throw error;
    } finally {
        isSubmitting.value = false;
    }
}

function resolveFormValues() {
    const payload = {
        idempotency_key: actionIdempotencyKey,
    };

    if (["create", "update", "edit"].includes(props.mode)) {
        Object.assign(payload, {
            final_department_id: final_department_id.value,
            transfer_date: transfer_date.value,
        });
    }

    if (props.mode === "create") {
        Object.assign(payload, {
            assigned_user_id: assigned_user_id.value,
            initial_department_id: initial_department_id.value,
        });
    } else if (props.request) {
        payload.id = props.request.id;
    }

    if (["approve", "deny"].includes(props.mode)) {
        payload.department_type = (
            props.request?.initial_department_approved_at
            || props.request?.initial_department_approved_by_user_id
        )
            ? "final"
            : "initial";
    }

    return payload;
}

async function fetchDepartmentsList() {

    isLoadingDepartments.value = true;
    Department.search({all: 0})
        .then((response) => {
            departmentsList.value = response.data || [];
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {

            isLoadingDepartments.value = false;
        })
}

async function fetchUsersList() {
    isLoadingUsers.value = true;
    const searchParams = {
        with_permissions_by_department: 1,
        with_departments: 1,
        without_pending_membership_requests: 1,
    };
    User.list(searchParams).then((response) => {
        usersList.value = response.data || [];
        
    })
    .catch((error) => {
        console.error(error);
    })
    .finally(() => {

        isLoadingUsers.value = false;
    })

}


</script>
<style scoped>

</style>
